// File upload configuration constants

// Supported image file types aligned with backend allowlist
export const SUPPORTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'image/gif',
  'image/webp',
  'image/avif',
  'image/bmp',
  'image/x-ms-bmp'
] as const;

// File size limits
export const FILE_SIZE_LIMITS = {
  // Maximum file size: 5MB
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB in bytes
  
  // Warning threshold for large files: 3MB
  LARGE_FILE_THRESHOLD: 3 * 1024 * 1024, // 3MB in bytes
} as const;

// File upload related constants
export const FILE_UPLOAD_CONFIG = {
  SUPPORTED_TYPES: SUPPORTED_IMAGE_TYPES,
  MAX_SIZE: FILE_SIZE_LIMITS.MAX_FILE_SIZE,
  LARGE_FILE_THRESHOLD: FILE_SIZE_LIMITS.LARGE_FILE_THRESHOLD,
  MAX_FILES: 4, // Maximum number of images allowed per message
  
  // File input accept attribute aligned with backend extensions
  ACCEPT_ATTRIBUTE: '.png,.jpg,.jpeg,.gif,.webp,.avif,.bmp',
  
  // Error messages
  MESSAGES: {
    UNSUPPORTED_FORMAT: (fileName: string) => 
      `File "${fileName}" is not a supported image format. Please upload one of: PNG, JPG, JPEG, GIF, WEBP, AVIF, BMP.`,
    FILE_TOO_LARGE: (fileName: string, sizeMB: string) => 
      `File "${fileName}" is too large (${sizeMB} MB). Please upload files smaller than 5 MB.`,
    TOO_MANY_FILES: (maxFiles: number) => 
      `You can only upload a maximum of ${maxFiles} images per message.`,
    PROCESSING_ERROR: 'Error processing images. Please try again.',
  }
} as const;

// Type definitions
export type SupportedImageType = typeof SUPPORTED_IMAGE_TYPES[number];
